import request from '@/utils/request'
import {
  praseStrEmpty
} from "@/utils/ruoyi";

// 查询用户列表
export function listUser(query) {
  return request({
    url: '/system/user/list',
    method: 'get',
    params: query
  })
}

// 查询用户详细
export function getUser(userId) {
  return request({
    url: '/system/user/' + praseStrEmpty(userId),
    method: 'get'
  })
}



// 查询用户详细
export function getUserFull(userId) {
  return request({
    url: '/system/user/getFullInfo/' + userId,
    method: 'get'
  })
}

// 新增用户
export function addUser(data) {
  return request({
    url: '/system/user',
    method: 'post',
    data: data
  })
}

// 修改用户
export function updateUser(data) {
  return request({
    url: '/system/user',
    method: 'put',
    data: data
  })
}

// 删除用户
export function delUser(userId) {
  return request({
    url: '/system/user/' + userId,
    method: 'delete'
  })
}

// 导出用户
export function exportUser(query) {
  return request({
    url: '/system/user/export',
    method: 'post',
    params: query
  })
}

// 用户密码重置
export function resetUserPwd(userId, password) {
  const data = {
    userId,
    password
  }
  return request({
    url: '/system/user/resetPwd',
    method: 'put',
    data: data
  })
}

// 用户状态修改
export function changeUserStatus(userId, status) {
  const data = {
    userId,
    status
  }
  return request({
    url: '/system/user/changeStatus',
    method: 'put',
    data: data
  })
}

// 查询用户个人信息
export function getUserProfile() {
  return request({
    url: '/system/user/profile',
    method: 'get'
  })
}

// 修改用户个人信息
export function updateUserProfile(data) {
  return request({
    url: '/system/user/profile',
    method: 'put',
    data: data
  })
}

// 用户密码重置
export function updateUserPwd(oldPassword, newPassword) {
  const data = {
    oldPassword,
    newPassword
  }
  return request({
    url: '/system/user/profile/updatePwd',
    method: 'put',
    params: data
  })
}

// 用户头像上传
export function uploadAvatar(data) {
  return request({
    url: '/system/user/profile/avatar',
    method: 'post',
    data: data
  })
}

// 下载用户导入模板
export function importTemplate() {
  return request({
    url: '/system/user/importTemplate',
    method: 'get'
  })
}

// 用户修改密码等信息
export function setUserEditPwd(data) {
  return request({
    url: '/oauth/server-audit/userAudit/firstResetPwd',
    method: 'post',
    data: data
  })
}

// 记录用户取消修改密码
export function setUserCancelEditPwd(userId) {
  return request({
    url: `/oauth/server-audit/userAudit/cancelResetPwd/${userId}`,
    method: 'put'
  })
}

// 查询当前账号绑定的孩子列表，通过账号密码
export function getChildList(data) {
  return request({
    url: '/oauth/server-audit/userAudit/getStudentParent',
    method: 'post',
    data: data
  })
}

// 查询当前(手机)账号绑定的孩子列表，通过账号密码
export function getChildListByPhoneNumber(data) {
  return request({
    url: '/oauth/server-audit/userAudit/getStudentByPhone',
    method: 'post',
    data: data
  })
}

// 查询当前账号绑定的孩子列表，通过token
export function getChildListByToken(data) {
  return request({
    url: '/oauth/server-audit/userAudit/getStudentParentByToken',
    method: 'post',
    data: data
  })
}

// 查询当前账号绑定的孩子列表
export function addStudentNew(data) {
  return request({
    url: '/oauth/server-audit/userAudit/addStudentNew',
    method: 'post',
    data: data
  })
}

// 删除当前账号绑定的孩子
export function deleteStudent(data) {
  return request({
    url: `/oauth/server-audit/userAudit/deleteStudentParent/${data.studentId}`,
    method: 'delete'
  })
}

// 获取学校组织列表
export function getDeptList(query) {
  return request({
    url: '/system/server-system/product/getDeptList',
    method: 'get',
    params: query
  })
}

// 免审核注册
export function addUserAuditParents(data) {
  return request({
    url: '/oauth/server-audit/userAudit/parents',
    method: 'post',
    data: data
  })
}

// 添加学生
export function addStudent(data) {
  return request({
    url: '/oauth/server-audit/userAudit/addStudent',
    method: 'post',
    data: data
  })
}